// @ts-nocheck

import { useMemo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { submitLoginJwt } from '../../actions/login';
import Client from '../../client';
import { changeLanguageL10n } from '../../i18n/l10n';
import { isLibrary } from '../../lib/useragent';
import { getAuthManager } from '../../managers/authManager';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserJwtToken } from '../../selectors/user/userPrimary.selector';
import type { Locale as Language, Licence } from '../../types/common';
import { Licences, Locales } from '../../types/common';
import type { JwtTokenInfosFromLib } from '../types/network';

type WinabetLibHandlerProps = {
  tokenInfos?: JwtTokenInfosFromLib;
  lang?: Language;
  licence?: Licence;
  children: React.ReactNode;
  oid: string;
};

const WinabetLibHandler = ({ tokenInfos = {}, lang = '', licence = '', oid, children }: WinabetLibHandlerProps) => {
  const dispatch = useDispatch();
  const currLicence = useSelector(selectRuntimeLicence);
  const nextLicence = useMemo(() => licence || currLicence, [licence, currLicence]);
  const currJwt = useSelector(selectUserJwtToken);
  const [initialized, setInitialized] = useState(false);

  const tryToChangeLanguage = useCallback(() => {
    if (lang && nextLicence) {
      switch (nextLicence) {
        case Licences.FR:
          if (lang !== Locales.FR) {
            changeLanguageL10n(Locales.EN);
          } else {
            changeLanguageL10n(Locales.FR);
          }
          break;
        case Licences.ES:
          changeLanguageL10n(Locales.ES);
          break;
        case Licences.DE:
          changeLanguageL10n(Locales.DE);
          break;
        case Licences.PT:
          changeLanguageL10n(Locales.PT);
          break;
        case Licences.IT:
          changeLanguageL10n(Locales.IT);
          break;
        default:
          changeLanguageL10n(Locales.EN);
      }
    }
  }, [lang, nextLicence]);

  const tryToSimulateLogin = useCallback(() => {
    if (!currJwt) {
      const { jwt, expirationDelay } = tokenInfos;

      if (jwt && expirationDelay && nextLicence) {
        getAuthManager().initWithJWT(jwt, expirationDelay);
        submitLoginJwt(jwt, expirationDelay, nextLicence)(dispatch);
        setInitialized(true);
      }
    }
  }, [dispatch, nextLicence, tokenInfos, currJwt]);

  const initialize = useCallback(() => {
    if (!initialized) {
      tryToChangeLanguage();
      tryToSimulateLogin();
    }
  }, [initialized, tryToChangeLanguage, tryToSimulateLogin]);

  useEffect(() => {
    if (isLibrary) {
      Client.tracker = oid;

      initialize();
    }
  }, [initialize, oid]);

  return children;
};

export default WinabetLibHandler;
